module.exports = __webpack_public_path__ + "img/qiang.593ce446.png";